<header class="navbar">
  <div class="navbar-container">
    <div class="navbar-content">
      
      <div class="logo-wrapper">
        <img src="assets/logo.jpeg" alt="The Detailer Logo" class="logo" />
      </div>

      <button class="btn-back" routerLink="/home">
        <span class="material-symbols-outlined icon-back">arrow_back_ios</span>
        Regresar
      </button>

    </div>
  </div>
</header>